module.exports = {
  "dof-card-group": {
    "flexDirection": "column"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-2d98b91b!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-card-group/index.vue
// module id = 456
// module chunks = 0 1